import React, { useState } from "react";
import { AnimatePresence, motion } from "motion/react";

const ProductCard = ({ imageurl, name, i }) => {
  const [index, setIndex] = useState(null);

  const variants = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: 50 },
  };
  return (
    <motion.div
      initial={{ opacity: 0.5, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: false, amount: 0.5 }}
      key={i}
      onMouseOver={() => setIndex(i)}
      onMouseOut={() => setIndex(null)}
      className="h-[300px] overflow-hidden relative"
    >
      <div className="">
        <img src={imageurl} className="w-full h-[300px] object-cover" />
      </div>
      <AnimatePresence>
        {index == i && (
          <motion.h3
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            {name}
          </motion.h3>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default ProductCard;
